import React, { useEffect, useState } from "react";
import useStyles from "../../../../components/common/model/styles";
import Popup from "../../../../components/common/model/Popup";
import closeIcon from "../../../../assets/closeModel.png";
import checkedIcon from "../../../../assets/check-mark.png";
import deleteIcon from "../../../../assets/trash.png";

import { DialogContent, DialogContentText, Tab, Tabs } from "@mui/material";

import CompanyInfoForm from "./CompanyInfoForm";
import SubscriptionPlanForm from "./SubscriptionPlanForm";
import FinancialInfoForm from "./FinancialInfoForm";
import EmailSettingForm from "./EmailSettingForm";

import Validation from "../../../../utils/Validation";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  addTelnetAction,
  initialClientLocalState,
  putEditClientAction,
  resetNewClientLocal,
  setAddTelnetAction,
  setEditClientAction,
  setNewClientLocal,
} from "../../../../store/reducers/adminClientsSlice";
import { companyInfoFields } from "../clientAllFields";
import { useToasts } from "react-toast-notifications";
import Notification from "../../../../components/common/notification/Notification";
import ResetFormAlert from "./ResetFormAlert";
import { setNotificationAction } from "../../../../store/reducers/mmymSlice";

const clientFormField: any = [
  companyInfoFields.find((field) => field?.id === "clientName"),
];

console.log("clientFormField-", clientFormField);

interface clientDetail {
  name: string | null;
  email: string | null;
  role: string | null;
  contactNumber: string | null;
  socialNumber: string | null;
  status: string[] | null;
  permission: string[] | null;
  uploadedImage: string | null;
}

interface ManageTenantProps {
  open: boolean; // Define the 'open' prop
  onHide: () => void; // Define the 'onHide' prop
  title: string; // Define the 'title' prop
  selectClient: any; // Adjust type as per your requirement
  action?: any;
}

export default function ManageTenant(props: ManageTenantProps) {
  const { addToast } = useToasts();
  const [formData, setFormData]: any = React.useState({});
  const [imageError, setImageError] = useState(false);
  const [isActionCalled, setIsActionCalled] = useState(false);
  const [btnErrors, setBtnErrors] = useState({
    btnCompany: false,
    btnSubscription: false,
    btnFinancial: false,
    btnEmail: false,
  });

  const { newClientLocal, isUniqueCompanyNameError, isUniqueVatError, isAddClientSuccess, isClientEditSuccess } = useSelector((state: any) => state?.adminClients);
  const [
    companyProfileError,
    companyProfileCheckValidator,
    companyProfileResetValidator,
    companyProfileResetAllValidator,
    companyProfileIsError,
  ]: any = Validation({
    clientName: newClientLocal?.companyProfile?.clientName || "",
    companyName: newClientLocal?.companyProfile?.companyName || "",
    phoneNumber: newClientLocal?.companyProfile?.phoneNumber || "",
    address: newClientLocal?.companyProfile?.address || "",
    vatPercent: newClientLocal?.companyProfile?.vatPercent || "",
    vatRegNo: newClientLocal?.companyProfile?.vatRegNo || "",
    dateFormat: newClientLocal?.companyProfile?.dateFormat || "",
    postCode: newClientLocal?.companyProfile?.postCode || "",
    generalWebsite: newClientLocal?.companyProfile?.generalWebsite || "",
    invoiceAddress: newClientLocal?.financialInformation?.invoiceAddress || "",
    paymentTerms: newClientLocal?.financialInformation?.paymentTerms || "",
    extendedLiabilityPercent: newClientLocal?.financialInformation?.extendedLiabilityPercent || "",
    extendedLiabilityTax: newClientLocal?.financialInformation?.extendedLiabilityTax || "",
    insuranceFixedRate: newClientLocal?.financialInformation?.insuranceFixedRate || "",
    email: newClientLocal?.emailSetting?.email || "",
    notificationEmail: newClientLocal?.emailSetting?.notificationEmail || "",
    // emailPassword: newClientLocal?.emailSetting?.emailPassword || "",
    // emailSignature: newClientLocal?.emailSetting?.emailSignature || "",
    // emailDisclaimer: newClientLocal?.emailSetting?.emailDisclaimer || "",
  });


  useEffect(() => {
    console.log("formData", formData);
    console.log("newClientLocal", newClientLocal);
  }, [formData, newClientLocal]);

  useEffect(() => {
    if(isAddClientSuccess || isClientEditSuccess) {
      dispatch(setAddTelnetAction(false))
      dispatch(setEditClientAction(false))
      dispatch(resetNewClientLocal())
      props.onHide();
      setImageError(false);
    }
  }, [isAddClientSuccess, isClientEditSuccess])

  React.useEffect(() => {
    const fields: any = {};
    clientFormField.map((field: any) => {
      fields[field?.id] = "";
      return true;
    });
    setFormData(fields);
  }, []);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if(props?.action !== 'plan'){
      companyProfileCheckValidator();
    }
    setTimeout(() => {
      setIsActionCalled(true);
      console.log("Api called here");
    }, 200);
  };

  useEffect(() => {
    if (isActionCalled) {
      if(props?.action === 'plan'){
        dispatch(addTelnetAction(newClientLocal));
      } else { 
        if (
          !companyProfileIsError() &&
          companyProfileError !== null &&
          isActionCalled
        ) {
          setIsActionCalled(false);
          console.log("Api called here 2");
          if(props?.action === 'edit'){
            dispatch(putEditClientAction(newClientLocal))
          } else{
            dispatch(addTelnetAction(newClientLocal));
          }
        } else {
          console.log("Api called here 3");
          setIsActionCalled(false);
          // companyProfileCheckValidator();
        }
      }
    }
  }, [isActionCalled]);

  const dispatch = useDispatch();

  const { selectClient, onHide, open, title } = props;
  const [clientDetail, setClientDetail] = useState<clientDetail>({
    name: null,
    email: null,
    role: null,
    contactNumber: null,
    socialNumber: null,
    status: null,
    permission: null,
    uploadedImage: null,
  });

  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState<
    "sm" | "xs" | "md" | "lg" | "xl" | false
  >("sm"); // Adjust the type definition
  const classes = useStyles();
  const handleImageUpload = (image: string | null) => {
    console.log("Uploaded image:", image);
    setClientDetail((prevDetail) => ({ ...prevDetail, uploadedImage: image }));
    if (image) {
      setImageError(false);
    }
  };

  const [stepActive, setStepActive] = useState(props?.action === "plan" ? 3 : 0);

  const hideHandler = () => {
    // if (stepActive === 0) {
    dispatch(resetNewClientLocal());
    dispatch(setNotificationAction({ message: [], severity: "error" }));
    props.onHide();
    setImageError(false);
    // } else {
    //   setStepActive(0);
    // }
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setStepActive(newValue);
  };

  const [alerModeShow, setAlertModelShow] = useState(false);

  const handleClear = () => {
    setAlertModelShow(true);
    setFormData(initialClientLocalState);
    // dispatch(resetNewClientLocal());
  };

  const handleTabError = (tab: any) => {
    if(tab === 1){
      if(
        companyProfileError?.clientName ||
        companyProfileError?.companyName ||
        companyProfileError?.phoneNumber ||
        companyProfileError?.address ||
        companyProfileError?.vatPercent ||
        companyProfileError?.vatRegNo ||
        companyProfileError?.dateFormat ||
        companyProfileError?.postCode ||
        companyProfileError?.generalWebsite ||
        isUniqueCompanyNameError ||
        isUniqueVatError
      ){
        return true
      } else {
        return false
      }
    }
    if(tab === 2){
      if(
        companyProfileError?.invoiceAddress ||
        companyProfileError?.paymentTerms ||
        companyProfileError?.extendedLiabilityPercent ||
        companyProfileError?.extendedLiabilityTax ||
        companyProfileError?.insuranceFixedRate
      ){
        return true
      } else {
        return false
      }
    }
    if(tab === 3){
      if(
        companyProfileError?.email ||
        companyProfileError?.notificationEmail
        // companyProfileError?.emailPassword ||
        // companyProfileError?.emailSignature ||
        // companyProfileError?.emailDisclaimer
      ){
        return true
      } else {
        return false
      }
    }
  }

  return (
    <>
      <Popup 
        open={open} // Example value, replace with your actual state or variable
        title={
          props?.action === 'plan' ? "Update Plan" :
          title
        } // Example title, replace with your actual title
        onHide={hideHandler}
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        aria-describedby="alert-dialog-slide-description"
        header={
          <>
            <img
              onClick={(e: any) => handleSubmit(e)}
              src={checkedIcon}
              className={classes.checkicons}
              alt="save"
            />
            <img
              onClick={handleClear}
              src={deleteIcon}
              className={classes.deleteicons}
              alt="delete"
            />
            <img
              onClick={hideHandler}
              src={closeIcon}
              className={classes.closeicons}
              alt="close"
            />
          </>
        }
      >
        <DialogContent>
          <DialogContentText className={classes.formAddBox}>
            <>
              <Notification />
              <Tabs
              className={`tab-root ${(
                  (handleTabError(1) && stepActive === 0) ? 'tab-error' :
                    (handleTabError(2) && stepActive === 1) ? 'tab-error' :
                      (handleTabError(3) && stepActive === 2)) ? 'tab-error': ''}`}
                style={{ fontSize: "12px", fontWeight: 600 }}
                value={stepActive}
                onChange={handleChange}
                variant="fullWidth"
                // indicatorColor="secondary"
                aria-label="visible arrows tabs example"
                sx={{
                  "& .MuiTab-root": {
                    fontSize: "13px", // Tab font size
                    fontWeight: 600,
                    backgroundColor: "#f5f5f5", // Tab background color
                  },
                  "& .Mui-selected": {
                    backgroundColor: "#e0e0e0", // Selected tab background color
                  },
                }}
              >
                <Tab label="Company Info" className={handleTabError(1) ? 'tab-error': ''}
                  disabled={
                    (props?.action === "plan") ? true :
                    (props?.action !== "edit" && newClientLocal?.tenantId) ? true : false
                  }
                />
                <Tab label="Financial Info" className={handleTabError(2) ? 'tab-error': ''}
                  disabled={
                    (props?.action === "plan") ? true :
                    ((props?.action !== "edit" && newClientLocal?.tenantId) || isUniqueCompanyNameError || isUniqueVatError) ? true : false
                  }
                />
                <Tab label="Email Settings" className={handleTabError(3) ? 'tab-error': ''}
                  disabled={(
                    (props?.action === "plan") ? true :
                    (props?.action !== "edit" && newClientLocal?.tenantId) || isUniqueCompanyNameError || isUniqueVatError) ? true : false
                  }
                />
                <Tab label="Subscription"
                  disabled={
                    (props?.action === "edit" ? true :  isUniqueCompanyNameError || isUniqueVatError) ? true : false}
                  />
              </Tabs>
            </>
            <>
              {stepActive === 0 && (
                <CompanyInfoForm
                  selectClient={""}
                  companyProfileError={companyProfileError}
                  formData={formData}
                  setFormData={setFormData}
                  resetValidator={companyProfileResetValidator}
                  checkValidator={companyProfileCheckValidator}
                  action={props?.action}
                />
              )}
            </>

            <>
              {stepActive === 1 && (
                <div style={{ margin: "40px 0px" }}>
                  <FinancialInfoForm
                    selectClient={""}
                    finanicalError={companyProfileError}
                    formData={formData}
                    setFormData={setFormData}
                    resetValidator={companyProfileResetValidator}
                    checkValidator={companyProfileCheckValidator}
                  />
                </div>
              )}
            </>
            <>
              {stepActive === 2 && (
                <div style={{ marginTop: "40px", minHeight: "390px" }}>
                  <EmailSettingForm
                    selectClient={""}
                    emailSettingError={companyProfileError}
                    formData={formData}
                    setFormData={setFormData}
                    checkValidator={companyProfileCheckValidator}
                    companyProfileIsError={companyProfileIsError}
                    action={props?.action}
                  />
                </div>
              )}
            </>
            <>
              {stepActive === 3 && (
                <div style={{ marginTop: "40px", minHeight: "390px" }}>
                  <SubscriptionPlanForm
                    selectClient={""}
                    formData={formData}
                    setFormData={setFormData}
                    action={props?.action}
                  />
                </div>
              )}
            </>
          </DialogContentText>
        </DialogContent>
      </Popup>
      {alerModeShow && <ResetFormAlert
        open={alerModeShow}
        title=""
        alertModalShow={alerModeShow}
        setAlertModelShow={setAlertModelShow}
        setFormData={setFormData}
        companyProfileResetAllValidator={companyProfileResetAllValidator}
      />}
    </>
  );
}
